import React from 'react';
import { getImageUrl } from '../../../utils/imageUtils';

const GallerySection = ({ gallery, galleryLimit, onSelectImage }) => (
    <div className="rounded-2xl bg-white border border-secondary-200 shadow-soft p-5">
        <div className="flex items-center justify-between gap-3 mb-4">
            <div className="text-sm font-semibold text-secondary-900">Галерея</div>
            <div className="text-xs text-secondary-500">{Math.min(gallery.length, galleryLimit)} / {gallery.length} фото</div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
            {gallery.slice(0, galleryLimit).map((img) => (
                <button
                    key={img.id}
                    type="button"
                    className="rounded-xl overflow-hidden border border-secondary-200 bg-white hover:shadow-soft transition"
                    onClick={() => onSelectImage(getImageUrl(img.image_url))}
                    title="Открыть"
                >
                    <div className="relative w-full" style={{ paddingTop: '100%' }}>
                        <img
                            src={getImageUrl(img.image_url)}
                            alt="gallery"
                            className="absolute inset-0 w-full h-full object-cover"
                            loading="lazy"
                        />
                    </div>
                </button>
            ))}
        </div>

        {gallery.length > galleryLimit && (
            <div className="mt-3 text-xs text-secondary-500">Показаны первые {galleryLimit} фото</div>
        )}
    </div>
);

export default GallerySection;
